import { Brand } from '@yandex-delivery/shared/types'
import React from 'react'
import ReactDOM from 'react-dom'

export const attachYmaps3React = async (res: typeof ymaps3, brand: Brand) => {
  const [ymaps3React, ymaps3Controls, ymaps3Clusterer] = await Promise.all([
    res.import(brand === 'yango' ? '@yangomaps/yangomaps-reactify' : '@yandex/ymaps3-reactify'),
    res.import(brand === 'yango' ? '@yangomaps/yangomaps-controls@0.0.1' : '@yandex/ymaps3-controls@0.0.1'),
    res.import(brand === 'yango' ? '@yangomaps/yangomaps-clusterer@0.0.1' : '@yandex/ymaps3-clusterer@0.0.1'),
  ])

  const reactify = ymaps3React.reactify.bindTo(React, ReactDOM)
  const components = reactify.module(res)
  const controlsComponents = reactify.module(ymaps3Controls)
  const clustererComponents = reactify.module(ymaps3Clusterer)

  return {...components, ...controlsComponents, ...clustererComponents}
}
